import React, { useEffect } from "react";
import { Textarea } from "../ui/textarea";
import { Input } from "../ui/input";
import SectionHeader from "./SectionHeader";
import { MapPin } from "lucide-react";
import Select from "react-select";
import { getAddressAPI } from "@/redux/Purchase/actions";
import {
  GetAccountAddressList,
  GetCountryStateList,
  GetUnLocationByISOCodeList,
} from "@/redux/Common/actions";

function AddressDetailsSection({
  expandedSections,
  onToggle,
  formData,
  handleInputChange,
  errors,
  inputClass,
  countryList,
  cpPositionList,
  RefreshPrintAddress,
  bookingData,
  handleSubmitAddress,
}) {
  const [locations, setLocations] = React.useState([]);
  const [loading, setloading] = React.useState(false);
  const [states, setStates] = React.useState([]);
  const [accountAddressList, setAccountAddressList] = React.useState([]);

  const _setAddress = async (id) => {
    const address = await getAddressAPI(id);
    handleInputChange({
      target: { name: "printaddressaccount", value: address },
    });
  };

  useEffect(() => {
    if (formData?.country) {
      const code = countryList
        ?.find((c) => c.incoterm === formData.country)
        ?.incoterm?.match(/\(([^)]+)\)/)?.[1];
      getLocations(code);
      getStates(code);
    }
  }, [formData?.country]);

  useEffect(() => {
    _GetAccountAddressList();
  }, []);

  const getLocations = (code) => {
    setloading(true);
    GetUnLocationByISOCodeList(code)
      .then((res) => {
        const options = (res || [])?.map((loc) => ({
          value: loc.unLocationLOCCode,
          label: loc.unLocationDescription,
        }));

        setLocations([...options]);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setloading(false);
        console.log("Request completed");
      });
  };
  const getStates = (code) => {
    setloading(true);
    GetCountryStateList(code)
      .then((res) => {
        const options = (res || [])?.map((state) => ({
          value: state?.stateCode,
          label: state?.stateName,
        }));

        setStates([...options]);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setloading(false);
      });
  };
  const _GetAccountAddressList = () => {
    GetAccountAddressList()
      .then((res) => {
        const options = (res || [])?.map((address) => ({
          value: address?.addressId,
          label: address?.address,
        }));

        setAccountAddressList([...options]);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const options = (countryList || [])?.map((loc) => {
    const match = (loc?.incoterm || "").match(/\(([^)]+)\)/);
    const code = match ? match[1] : null;
    return {
      value: code,
      label: loc?.incoterm,
    };
  });

  return (
    <>
      <div className="bg-white dark:bg-slate-900 rounded-lg shadow-sm border border-slate-200 dark:border-slate-800 overflow-hidden">
        <SectionHeader
          icon={MapPin}
          title="Address Details"
          color="bg-emerald-600"
          section="s3"
          toggleSection={onToggle}
          expandedSections={expandedSections}
        />
        {expandedSections.s3 && (
          <div className="p-4  border-slate-200 dark:border-slate-800">
            <div className="grid grid-cols-2 gap-6 items-start">
              <div className="grid grid-cols-12 items-center gap-2">
                <label className="col-span-12 text-xs font-medium text-slate-600 dark:text-slate-400">
                  Company Name: <span className="text-red-500">*</span>
                </label>
                <div className="col-span-12">
                  <Input
                    type="text"
                    value={formData?.companyname2}
                    onChange={handleInputChange}
                    name="companyname2"
                    className={inputClass}
                  />
                  {errors.companyname2 && (
                    <p className="text-red-500 text-xs mt-1">
                      {errors.companyname2}
                    </p>
                  )}
                </div>
              </div>
              <div className="grid grid-cols-12 items-center gap-2">
                <label className="col-span-12 text-xs font-medium text-slate-600 dark:text-slate-400">
                  Fax:
                </label>
                <div className="col-span-12">
                  <Input
                    type="text"
                    value={formData?.fax}
                    onChange={handleInputChange}
                    name="fax"
                    className={inputClass}
                  />
                </div>
              </div>

              <div className="grid grid-cols-12 items-center gap-2">
                <label className="col-span-12 text-xs font-medium text-slate-600 dark:text-slate-400">
                  Parent Company:
                </label>
                <div className="col-span-12">
                  <Input
                    type="text"
                    value={formData?.parentcompany}
                    onChange={handleInputChange}
                    name="parentcompany"
                    className={inputClass}
                  />
                </div>
              </div>
              <div className="grid grid-cols-12 items-center gap-2">
                <label className="col-span-12 text-xs font-medium text-slate-600 dark:text-slate-400">
                  Tel 2:
                </label>
                <div className="col-span-12">
                  <Input
                    type="text"
                    value={formData?.tel2}
                    onChange={handleInputChange}
                    name="tel2"
                    className={inputClass}
                  />
                </div>
              </div>

              <div className="grid grid-cols-12 items-center gap-2">
                <label className="col-span-12 text-xs font-medium text-slate-600 dark:text-slate-400">
                  Office Type:
                </label>
                <div className="col-span-12">
                  <select
                    className="w-full p-2 border border-slate-300 dark:border-slate-700 rounded-md bg-white dark:bg-slate-800 text-slate-900 dark:text-white"
                    name="ddlofficeType2"
                    value={String(formData?.ddlofficeType2)}
                    onChange={(e) =>
                      handleInputChange({
                        target: {
                          name: "ddlofficeType2",
                          value: Number(e.target.value),
                        },
                      })
                    }
                  >
                    <option value="0">Select</option>
                    <option value="1">Head Office</option>
                    <option value="2">Branch Office</option>
                  </select>
                </div>
              </div>

              <div className="grid grid-cols-12 items-center gap-2">
                <label className="col-span-12 text-xs font-medium text-slate-600 dark:text-slate-400">
                  Toll Free:
                </label>
                <div className="col-span-12">
                  <Input
                    type="text"
                    value={formData?.tollfree}
                    onChange={handleInputChange}
                    name="tollfree"
                    className={inputClass}
                  />
                </div>
              </div>

              <div className="grid grid-cols-12 items-center gap-2">
                <label className="col-span-12 text-xs font-medium text-slate-600 dark:text-slate-400">
                  Address 1: <span className="text-red-500">*</span>
                </label>
                <div className="col-span-12">
                  <Input
                    type="text"
                    value={formData?.address1}
                    onChange={handleInputChange}
                    name="address1"
                    className={inputClass}
                  />
                  {errors.address1 && (
                    <p className="text-red-500 text-xs mt-1">
                      {errors.address1}
                    </p>
                  )}
                </div>
              </div>

              <div className="grid grid-cols-12 items-center gap-2">
                <label className="col-span-12 text-xs font-medium text-slate-600 dark:text-slate-400">
                  Alternative Email:
                </label>
                <div className="col-span-12">
                  <Input
                    type="text"
                    value={formData?.altemail}
                    onChange={handleInputChange}
                    name="altemail"
                    className={inputClass}
                  />
                </div>
              </div>

              <div className="grid grid-cols-12 items-center gap-2">
                <label className="col-span-12 text-xs font-medium text-slate-600 dark:text-slate-400">
                  Address 2:
                </label>
                <div className="col-span-12">
                  <Input
                    type="text"
                    value={formData?.address2}
                    onChange={handleInputChange}
                    name="address2"
                    className={inputClass}
                  />
                </div>
              </div>

              <div className="grid grid-cols-12 items-center gap-2">
                <label className="col-span-12 text-xs font-medium text-slate-600 dark:text-slate-400">
                  Accounting Email:
                </label>
                <div className="col-span-12">
                  <Input
                    type="text"
                    value={formData?.accountingemail}
                    onChange={handleInputChange}
                    name="accountingemail"
                    className={inputClass}
                  />
                </div>
              </div>

              <div className="grid grid-cols-12 items-center gap-2">
                <label className="col-span-12 text-xs font-medium text-slate-600 dark:text-slate-400">
                  Address 3:
                </label>
                <div className="col-span-12">
                  <Input
                    type="text"
                    value={formData?.address3}
                    onChange={handleInputChange}
                    name="address3"
                    className={inputClass}
                  />
                </div>
              </div>

              <div className="grid grid-cols-12 items-center gap-2">
                <label className="col-span-12 text-xs font-medium text-slate-600 dark:text-slate-400">
                  Notification Email:
                </label>
                <div className="col-span-12">
                  <Input
                    type="text"
                    value={formData?.notificationemail}
                    onChange={handleInputChange}
                    name="notificationemail"
                    className={inputClass}
                  />
                </div>
              </div>

              <div className="grid grid-cols-12 items-center gap-2">
                <label className="col-span-12 text-xs font-medium text-slate-600 dark:text-slate-400">
                  Firms Code:
                </label>
                <div className="col-span-12">
                  <Input
                    type="text"
                    value={formData?.firmcode}
                    onChange={handleInputChange}
                    name="firmcode"
                    className={inputClass}
                  />
                </div>
              </div>

              <div className="grid grid-cols-12 items-center gap-2">
                <label className="col-span-12 text-xs font-medium text-slate-600 dark:text-slate-400">
                  Do Not Send Notification:
                </label>
                <div className="col-span-12">
                  <Input
                    type="checkbox"
                    className="w-4 h-4"
                    value={formData?.dontsendnotification}
                    checked={!!formData?.dontsendnotification}
                    onChange={handleInputChange}
                    name="dontsendnotification"
                  />
                </div>
              </div>

              <div className="grid grid-cols-12 items-center gap-2">
                <label className="col-span-12 text-xs font-medium text-slate-600 dark:text-slate-400">
                  Country: <span className="text-red-500">*</span>
                </label>
                <div className="col-span-12">
                  <Select
                    options={options}
                    value={options?.find(
                      (opt) => opt.label === formData?.country,
                    )}
                    onChange={(selected) => {
                      handleInputChange({
                        target: {
                          name: "country",
                          value: selected?.label || "",
                        },
                      });
                    }}
                    placeholder="Select Country"
                    classNames={{
                      control: (state) =>
                        `min-h-[38px] rounded-md border  bg-white dark:bg-slate-800 text-slate-900 dark:text-white 
                                                                    ${state.isFocused ? "border-[#0072FF] ring-1 ring-[#0072FF]" : "border-slate-300 dark:border-slate-700"}`,

                      menu: () =>
                        "bg-white dark:bg-slate-800 border border-slate-300 dark:border-slate-700",
                      option: ({ isFocused, isSelected }) =>
                        `cursor-pointer px-3 py-2   ${isSelected ? "bg-[#0072FF] text-white" : ""}
                                                                        ${isFocused && !isSelected ? "bg-slate-100 dark:bg-slate-700" : ""}       text-slate-900 dark:text-white`,

                       singleValue: () => "text-slate-900 dark:text-white",

  // optional placeholder style
  placeholder: () => "text-slate-400 dark:text-slate-500",
                    }} 
                  />
                  {errors.country && (
                    <p className="text-red-500 text-xs mt-1">
                      {errors.country}
                    </p>
                  )}
                </div>
              </div>

              <div className="grid grid-cols-12 items-center gap-2">
                <label className="col-span-12 text-xs font-medium text-slate-600 dark:text-slate-400">
                  Vendor Eligibe for 1099:
                </label>
                <div className="col-span-12">
                  <Input
                    type="checkbox"
                    className="w-4 h-4"
                    value={formData?.chkvendoreligible}
                    checked={!!formData?.chkvendoreligible}
                    onChange={handleInputChange}
                    name="chkvendoreligible"
                  />
                </div>
              </div>

           
                 <div className="grid grid-cols-12 items-center gap-2">
                <label className="col-span-12 text-xs font-medium text-slate-600 dark:text-slate-400">
                  State: <span className="text-red-500">*</span>
                </label>
                {/* <div className="col-span-12">
                  <Select
                    options={states}
                    value={states?.find((opt) => opt.label === formData?.state)}
                    onChange={(selected) =>
                      handleInputChange({
                        target: { name: "state", value: selected?.label || "" },
                      })
                    }
                    isDisabled={!formData?.country || loading}
                    placeholder="Select state"
                    classNames={{
                      control: (state) =>
                        `min-h-[38px] rounded-md border  bg-white dark:bg-slate-800 text-slate-900 dark:text-white 
                                                                    ${state.isFocused ? "border-[#0072FF] ring-1 ring-[#0072FF]" : "border-slate-300 dark:border-slate-700"}`,

                      menu: () =>
                        "bg-white dark:bg-slate-800 border border-slate-300 dark:border-slate-700",
                      option: ({ isFocused, isSelected }) =>
                        `cursor-pointer px-3 py-2   ${isSelected ? "bg-[#0072FF] text-white" : ""}
                                                                        ${isFocused && !isSelected ? "bg-slate-100 dark:bg-slate-700" : ""}       text-slate-900 dark:text-white`,

                             singleValue: () => "text-slate-900 dark:text-white",
  placeholder: () => "text-slate-400 dark:text-slate-500",
                    }} 
                  />
                  {errors.state && (
                    <p className="text-red-500 text-xs mt-1">{errors.state}</p>
                  )}
                </div> */}
<div className="col-span-12">
  <input
    type="text"
    name="state"
    value={formData?.state || ""}
    onChange={handleInputChange}
    disabled={!formData?.country || loading}
    placeholder="Enter state"
    className={`w-full min-h-[38px] rounded-md border px-3 py-2 bg-white dark:bg-slate-800 text-slate-900 dark:text-white placeholder:text-slate-400 dark:placeholder:text-slate-500 focus:outline-none focus:ring-1 focus:ring-[#0072FF] focus:border-[#0072FF]
      ${
        !formData?.country || loading
          ? "opacity-50 cursor-not-allowed"
          : ""
      }
      border-slate-300 dark:border-slate-700`}
  />

  {errors.state && (
    <p className="text-red-500 text-xs mt-1">{errors.state}</p>
  )}
</div>



              </div>
              <div className="grid grid-cols-12 items-center gap-2">
                <label className="col-span-12 text-xs font-medium text-slate-600 dark:text-slate-400">
                  Vendor's Tax ID:
                </label>
                <div className="col-span-12">
                  <Input
                    type="text"
                    value={formData?.vendortaxid}
                    onChange={handleInputChange}
                    name="vendortaxid"
                    className={inputClass}
                  />
                </div>
              </div>

              <div className="grid grid-cols-12 items-center gap-2">
                <label className="col-span-12 text-xs font-medium text-slate-600 dark:text-slate-400">
                  City: <span className="text-red-500">*</span>
                </label>
                {/* <div className="col-span-12">
                  <Select
                    options={locations}
                    value={locations?.find(
                      (opt) => opt.label === formData?.city,
                    )}
                    onChange={(selected) =>
                      handleInputChange({
                        target: { name: "city", value: selected?.label || "" },
                      })
                    }
                    isDisabled={!formData?.country || loading}
                    placeholder="Select city"
                      classNames={{
                      control: (state) =>
                        `min-h-[38px] rounded-md border  bg-white dark:bg-slate-800 text-slate-900 dark:text-white 
                                                                    ${state.isFocused ? "border-[#0072FF] ring-1 ring-[#0072FF]" : "border-slate-300 dark:border-slate-700"}`,

                      menu: () =>
                        "bg-white dark:bg-slate-800 border border-slate-300 dark:border-slate-700",
                      option: ({ isFocused, isSelected }) =>
                        `cursor-pointer px-3 py-2   ${isSelected ? "bg-[#0072FF] text-white" : ""}
                                                                        ${isFocused && !isSelected ? "bg-slate-100 dark:bg-slate-700" : ""}       text-slate-900 dark:text-white`,

                           singleValue: () => "text-slate-900 dark:text-white",
  placeholder: () => "text-slate-400 dark:text-slate-500",
                    }} 
                  />
                  {errors.city && (
                    <p className="text-red-500 text-xs mt-1">{errors.city}</p>
                  )}
                </div> */}
<div className="col-span-12">
  <input
    type="text"
    name="city"
    value={formData?.city || ""}
    onChange={handleInputChange}
    disabled={!formData?.country || loading}
    placeholder="Enter city"
    className={`w-full min-h-[38px] rounded-md border px-3 py-2 bg-white dark:bg-slate-800 text-slate-900 dark:text-white placeholder:text-slate-400 dark:placeholder:text-slate-500 focus:outline-none focus:ring-1 focus:ring-[#0072FF] focus:border-[#0072FF]
      ${
        !formData?.country || loading
          ? "opacity-50 cursor-not-allowed"
          : ""
      }
      border-slate-300 dark:border-slate-700`}
  />

  {errors.city && (
    <p className="text-red-500 text-xs mt-1">{errors.city}</p>
  )}
</div>


              </div>
              <div className="grid grid-cols-12 items-center gap-2">
                <label className="col-span-12 text-xs font-medium text-slate-600 dark:text-slate-400">
                  Print Address:
                </label>
                <div className="col-span-12">
                  <Textarea
                    rows="6"
                    value={formData?.printaddress}
                    onChange={handleInputChange}
                    name="printaddress"
                    className={inputClass}
                  />
                </div>
              </div>

             <div className="grid grid-cols-12 items-center gap-2">
                <label className="col-span-12 text-xs font-medium text-slate-600 dark:text-slate-400">
                  Postal Code: <span className="text-red-500">*</span>
                </label>
                <div className="col-span-12">
                  <Input
                    type="text"
                    value={formData?.postalcode}
                    onChange={handleInputChange}
                    name="postalcode"
                    className={inputClass}
                  />
                  {errors.postalcode && (
                    <p className="text-red-500 text-xs mt-1">
                      {errors.postalcode}
                    </p>
                  )}
                </div>
              </div>

              <div className="grid grid-cols-12 items-end gap-2 h-full">
                <div className="col-span-9">
                  <button
                    onClick={RefreshPrintAddress}
                    type="button"
                    className="px-4 py-2 text-sm bg-[#0072FF] hover:bg-[#0062DD] text-white rounded-lg font-medium transition-all flex items-center space-x-1"
                  >
                    Refresh
                  </button>
                </div>
              </div>

              <div className="grid grid-cols-12 items-center gap-2">
                <label className="col-span-12 text-xs font-medium text-slate-600 dark:text-slate-400">
                  Province:
                </label>
                <div className="col-span-12">
                  <Input
                    type="text"
                    value={formData?.province}
                    onChange={handleInputChange}
                    name="province"
                    className={inputClass}
                  />
                </div>
              </div>

              <div className="grid grid-cols-12 items-center gap-2">
                <label className="col-span-12 text-xs font-medium text-slate-600 dark:text-slate-400">
                  Select Account Address:
                </label>
                <div className="col-span-12">
                  <Select
                    options={accountAddressList}
                    value={accountAddressList?.find(
                      (opt) =>
                        Number(opt?.value) ===
                        Number(formData?.ddlsalectaccountaddress || "0"),
                    )}
                    onChange={(selected) => {
                      handleInputChange({
                        target: {
                          name: "ddlsalectaccountaddress",
                          value: selected?.value || "",
                        },
                      });

                      _setAddress(selected?.value);
                    }}
                    placeholder="Select city"
                       classNames={{
                      control: (state) =>
                        `min-h-[38px] rounded-md border  bg-white dark:bg-slate-800 text-slate-900 dark:text-white 
                                                                    ${state.isFocused ? "border-[#0072FF] ring-1 ring-[#0072FF]" : "border-slate-300 dark:border-slate-700"}`,

                      menu: () =>
                        "bg-white dark:bg-slate-800 border border-slate-300 dark:border-slate-700",
                      option: ({ isFocused, isSelected }) =>
                        `cursor-pointer px-3 py-2   ${isSelected ? "bg-[#0072FF] text-white" : ""}
                                                                        ${isFocused && !isSelected ? "bg-slate-100 dark:bg-slate-700" : ""}       text-slate-900 dark:text-white`,

                            singleValue: () => "text-slate-900 dark:text-white",
  placeholder: () => "text-slate-400 dark:text-slate-500",
                    }}  this use for dark and light mode
                  
                  />
                </div>
              </div>

              <div className="grid grid-cols-12 items-center gap-2">
                <label className="col-span-12 text-xs font-medium text-slate-600 dark:text-slate-400">
                  Contact Person:
                </label>
                <div className="col-span-12">
                  <Input
                    type="text"
                    value={formData?.contactperson}
                    onChange={handleInputChange}
                    name="contactperson"
                    className={inputClass}
                  />
                </div>
              </div>

              <div className="grid grid-cols-12 items-center gap-2">
                <label className="col-span-12 text-xs font-medium text-slate-600 dark:text-slate-400">
                  Print Address(Accounting):
                </label>
                <div className="col-span-12">
                  <Textarea
                    rows="6"
                    value={formData?.printaddressaccount}
                    onChange={handleInputChange}
                    name="printaddressaccount"
                    className={inputClass}
                  />
                </div>
              </div>

              <div className="grid grid-cols-12 items-center gap-2">
                <label className="col-span-12 text-xs font-medium text-slate-600 dark:text-slate-400">
                  Contact Person Position:
                </label>
                <div className="col-span-12">
                  <select
                    className="w-full p-2 border border-slate-300 dark:border-slate-700 rounded-md bg-white dark:bg-slate-800 text-slate-900 dark:text-white"
                    value={formData?.ddlcontactpersonposition || ""}
                    onChange={handleInputChange}
                    name="ddlcontactpersonposition"
                  >
                    <option value="">Select</option>
                    {cpPositionList.map((position) => (
                      <option
                        key={position.positionid}
                        value={position.positionid}
                      >
                        {position.positionname}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="grid grid-cols-12 items-center gap-2">
                <label className="col-span-12 text-xs font-medium text-slate-600 dark:text-slate-400">
                  Email:
                </label>
                <div className="col-span-12">
                  <Input
                    type="text"
                    value={formData?.email}
                    onChange={handleInputChange}
                    name="email"
                    className={inputClass}
                  />
                </div>
              </div>
              <div className="grid grid-cols-12 items-center gap-2">
                <label className="col-span-12 text-xs font-medium text-slate-600 dark:text-slate-400">
                  Office Tel:
                </label>
                <div className="col-span-12">
                  <Input
                    type="text"
                    value={formData?.officetel}
                    onChange={handleInputChange}
                    name="officetel"
                    className={inputClass}
                  />
                </div>
              </div>
              <div className="grid grid-cols-12 items-center gap-2">
                <label className="col-span-12 text-xs font-medium text-slate-600 dark:text-slate-400">
                  Customer SAP A\C:
                </label>
                <div className="col-span-12">
                  <Input
                    type="text"
                    value={formData?.customersapact}
                    onChange={handleInputChange}
                    name="customersapact"
                    className={inputClass}
                  />
                </div>
              </div>
              <div className="grid grid-cols-12 items-center gap-2">
                <label className="col-span-12 text-xs font-medium text-slate-600 dark:text-slate-400">
                  Vendor SAP A\C:
                </label>
                <div className="col-span-12">
                  <Input
                    type="text"
                    value={formData?.vendorsapact}
                    onChange={handleInputChange}
                    name="vendorsapact"
                    className={inputClass}
                  />
                </div>
              </div>
              <div className="grid grid-cols-12 items-center gap-2">
                <label className="col-span-12 text-xs font-medium text-slate-600 dark:text-slate-400">
                  QuickBook Customer ID:
                </label>
                <div className="col-span-12">
                  <Input
                    type="text"
                    value={formData?.quickbookcstid}
                    onChange={handleInputChange}
                    name="quickbookcstid"
                    className={inputClass}
                  />
                </div>
              </div>
              <div className="grid grid-cols-12 items-center gap-2">
                <label className="col-span-12 text-xs font-medium text-slate-600 dark:text-slate-400">
                  QuickBook Vendor ID:
                </label>
                <div className="col-span-12">
                  <Input
                    type="text"
                    value={formData?.quickbookvendorid}
                    onChange={handleInputChange}
                    name="quickbookvendorid"
                    className={inputClass}
                  />
                </div>
              </div>

              <div className="grid grid-cols-12 items-center gap-2">
                <label className="col-span-12 text-xs font-medium text-slate-600 dark:text-slate-400"></label>
                <div className="col-span-12">
                  <label className="col-span-12 text-xs font-medium text-slate-600 dark:text-slate-400"></label>
                </div>
              </div>
            </div>

            {/* Add New Address */}
            {bookingData && (
              <div className="flex justify-end space-x-2">
                <button
                  onClick={handleSubmitAddress}
                  type="button"
                  className="px-4 py-2 text-sm bg-[#0072FF] hover:bg-[#0062DD] text-white rounded-lg font-medium transition-all flex items-center space-x-1"
                >
                  <span>+ Save New Address</span>
                </button>
              </div>
            )}
          </div>
        )}
      </div>
    </>
  );
}

export default AddressDetailsSection;
